import abdur from "../assets/images/team/Abur Rauf Ripon.webp";
import anisur from "../assets/images/team/Anisur Rahman.webp";
import avikesh from "../assets/images/team/Avikesh Kumar Singh.webp";
import banoja from "../assets/images/team/Banoja Acharya.webp";
import bhumisuta from "../assets/images/team/Bhumisuta Giri.webp";
import christina from "../assets/images/team/Christina Murzello.webp";
import falguni from "../assets/images/team/Falguni Pan.webp";
import habib from "../assets/images/team/Md. Habib Naziat.webp";
import moumita from "../assets/images/team/Moumita Ghoshal Mendiratta.webp";
import prashant from "../assets/images/team/Prashant Kolleri.webp";
import prasun from "../assets/images/team/Prasun Basu.webp";
import prottay from "../assets/images/team/Prottay Mesbah.webp";
import ranjit from "../assets/images/team/Ranjit Mijar.webp";
import saradeeya from "../assets/images/team/Saradeeya Banerjee.webp";
import shonali from "../assets/images/team/Shonali Ghosh.webp";
import susmita from "../assets/images/team/Susmita Dutta.webp";
import tanishq from "../assets/images/team/Tanishq Bindra.webp";
import tennis from "../assets/images/team/Tennis Mathew.webp";

export const teamData = [
    {
        "Sr no.": 1,
        "Name": "Prasun Basu",
        "Image": prasun,
        "Personal Side": "I am a curious, analytical, and creative problem-solver with a passion for science and innovation.  A driven perfectionist, I excel in brand management, marketing, and analytics. With a heart of gold, I prioritize family, mentoring, and helping others.",
        "Funny Job Title": "- Brand Jedi & Problem Slayer\n- Sweeper cum Quarter Back",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/prasun-basu?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAABFKfooBOBSflbqlpBP_OHuzGDNd8GP_VkM&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3B5KweviMjTVSUSNPYwtTQ4Q%3D%3D"
    },
    {
        "Sr no.": 2,
        "Name": "Prashant Kolleri",
        "Image": prashant,
        "Personal Side": "I thrive on problem-solving, collaborating with teams, and nurturing talent, staying calm even under pressure. A lover of art and culture, I enjoy reading, watching cultural documentaries, and exploring regional Indian and North Asian cinema. Fitness adds balance to my life, keeping me energized and ready for new challenges.",
        "Funny Job Title": "Culture Curator and Talent Architect",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/prashant-kolleri-7620185?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAADkWzoBjZ_A79KOq0WFvoQuixHFscwe2aE&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3B%2BUUbWDQHTnq1VNFtr13qlQ%3D%3D"
    },
    {
        "Sr no.": 3,
        "Name": "Banoja Acharya",
        "Image": banoja,
        "Personal Side": "I am a paradoxical blend of organization and chaos, thriving on building stability while creating new things. A yoga addict and curious traveler, I embrace exploration and mindfulness. I cherish my sleep as a cornerstone of balance and unwind with crosswords, finding joy in solving both words and worlds.",
        "Funny Job Title": "- Zen Problem Solver\n- Chief Harmony Builder",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/banoja-acharya-a5650617?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAAN02mIBNvR6QZEul9uVNlhOBK2MsnlS2OM&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3B45tewldlR3izrHIDUQ4vlg%3D%3D"
    },
    {
        "Sr no.": 4,
        "Name": "Shonali Ghosh",
        "Image": shonali,
        "Personal Side": "I seek the unexpected, embracing creativity and determination to solve challenges. Guided by compassion, I find joy in wanderlust and dream of a mountain retreat to rescue and nurture creatures great and small, dedicating my life to providing them with love, care, and a safe haven.",
        "Funny Job Title": "- Compassionate Trailblazer\n- Nomadic Nurturer",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/shonali-ghosh-52595379/"
    },
    {
        "Sr no.": 5,
        "Name": "Tennis Mathew",
        "Image": tennis,
        "Personal Side": "I am an outdoor and sports enthusiast who loves running, badminton, trekking, and wildlife safaris. An avid reader of non-fiction and business books, I thrive on taking up new challenges, cherish meaningful friendships, and find joy in helping others while exploring life\u2019s adventures.",
        "Funny Job Title": "Adventure Strategist and Challenge Seeker",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/tennismathew?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAAFhuaIBjeFq4YqWb7P6ZyTSmzvYw3VjRTY&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3B5MXsjmKTSquPLG0tvFyLGw%3D%3D"
    },
    {
        "Sr no.": 6,
        "Name": "Moumita Ghoshal",
        "Image": moumita,
        "Personal Side": "I am a creative soul with a passion for art, dance, and storytelling. Warm, empathetic, and nurturing, I love teaching and seeing the world through a child's eyes.  Observant and intuitive, I excel at understanding others.  Though kind-hearted, I value my space and cherish spreading joy, beauty, and positivity.",
        "Funny Job Title": "Chief Joy Officer (CJO)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/moumita-ghoshal-55b90613?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAALNx5cBcg11LcmIT_6C4tZeLokJJuI_HmA&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BRDkVrB5%2BT2yCkhMyKZQnCg%3D%3D"
    },
    {
        "Sr no.": 7,
        "Name": "Prottay Rano Mesbah",
        "Image": prottay,
        "Personal Side": "I'm a passionate comic book fan, with Batman as my favorite superhero. I turn to American comics for comfort and prefer quiet weekends at home reading. A dedicated European football fan, I support Real Madrid. I'm also a rock music enthusiast, with a love for Bangladeshi bands and Pink Floyd.",
        "Funny Job Title": "Chief Crusader of Comics, Chords, & Champions League (C4L)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/prottay-mesbah-81539159?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAAxWGFEBVoMCG4crpWPTj7LM5p_7GFCUt7A&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BZkW6hB9gRuaQ2c0EaCHhKw%3D%3D"
    },
    {
        "Sr no.": 8,
        "Name": "Habib Naziat",
        "Image": habib,
        "Personal Side": "I enjoy exploring new places, connecting with people, and experiencing diverse cultures. Football keeps me energized, while movies and books inspire and transport me to new worlds. With a curious spirit, I embrace every adventure, finding joy in learning, growing, and appreciating life\u2019s numerous opportunities.",
        "Funny Job Title": "Chief Adventure Officer (CAO)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/habib-naziat?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAACITHcABNb9J--39mXQm89O_Wgwa_bjcDdA&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3B7rZ7%2F%2FHiQU2hL2PTH%2Besfg%3D%3D"
    },
    {
        "Sr no.": 9,
        "Name": "Susmita Dutta",
        "Image": susmita,
        "Personal Side": "I distinguish between life and living and try to find a fine balance and harmony that nourishes both. Solitude helps me to introspect and it provides tranquility to my mind. As a person, I am quiet, co-operative yet straightforward; often unafraid to question the limiting belief/action, and like to lead. Curiosity and experience are my primary tools to learn new things. I love to make paintings and write op-eds, blog posts, and others to express my understanding of this world.",
        "Funny Job Title": "- Philosopher-in-Chief\n- The Quiet Visionary",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/susmita-dutta-921a6086?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        "Sr no.": 10,
        "Name": "Falguni Pan",
        "Image": falguni,
        "Personal Side": "I'm a passionate traveler, constantly learning and exploring new places and ideas. I love living one day at a time, embracing every opportunity for growth. Theatre and poetry are my creative outlets, and I believe in fostering a world where equality and kindness thrive. Every day is a new adventure!",
        "Funny Job Title": "Chief Learning Officer (CLO)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/falguni-pan-31b926251?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAD5ASEcB7Q37DyStw8VZCMQ7mWKrZkWwueg&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BW9Ys9ik%2BQr6AJ1sAVR2BGQ%3D%3D"
    },
    {
        "Sr no.": 11,
        "Name": "Avikesh Kumar Singh",
        "Image": avikesh,
        "Personal Side": "I am a cricket enthusiast with a calm and patient demeanor. I enjoy having fun, with a great sense of humor that lightens any mood. A tech-savvy multitasker, I keep up with the latest trends. I am also a music lover, balancing my passions with a laid-back, approachable attitude.",
        "Funny Job Title": "Head of Wickets, Widgets, & Wit (HW3)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/avikesh-kumar-singh-21898931a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        "Sr no.": 12,
        "Name": "Bhumisuta Giri",
        "Image": bhumisuta,
        "Personal Side": "I am an avid photographer, with a passion in capturing life's moments. I enjoy cooking various cuisines from around the world and value a good cup of coffee. With a love for dancing and nature, I am caring, sincere, and always bring a positive energy to those around me.",
        "Funny Job Title": "Chief Executive of Clicks, Kicks, & Coffee (CEC3)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/bhumisuta-giri-35603127a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        "Sr no.": 13,
        "Name": "Tanishq Bindra",
        "Image": tanishq,
        "Personal Side": "I genuinely love helping others and connecting with people\u2014I guess you could say I'm a total people's person! Working out is my solace; it keeps me energized and grounded. Oh, and fun fact: I'm a huge foodie! I absolutely love exploring new cuisines and flavors.",
        "Funny Job Title": "Director of Gains, Grub & Good Vibes (DG3)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/tanishq-kaur-bindra?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADaes3kBWmIbotQiOpGv0alZ5E3DSkcbxrM&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3B29lAkASdTD%2B1zHvi0huTCA%3D%3D"
    },
    {
        "Sr no.": 14,
        "Name": "Saradeeya Banerjee",
        "Image": saradeeya,
        "Personal Side": "I am a curious and creative individual with a passion for exploring new ideas. I enjoy reading, digital painting, photography, and music while travelling. Always eager to learn, I approach challenges with a blend of creativity and analytical thinking.",
        "Funny Job Title": "- Chief Creativity Officer\n- Creative Problem Solver",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/saradeeya-banerjee-962aa915a/"
    },
    {
        "Sr no.": 15,
        "Name": "Abdur Rauf Ripon",
        "Image": abdur,
        "Personal Side": "I am a warm and curious individual, with a passion for exploring new cuisines and discovering unique flavors.  A devoted book lover, I also enjoy watching Bangla dramas that connect me to my roots. Deeply compassionate, I am actively engaged in social work, reflecting my commitment to positively impacting others.",
        "Funny Job Title": "Head of Tastes & Tales",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/abdur-rauf-ripon-8b8507214?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADYuMEwB2IAEwfkCvv1yCyDSLl5lRULwCdg&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3Br3hrbKKaRrSyS5d%2B6WcvKw%3D%3D"
    },
    {
        "Sr no.": 16,
        "Name": "Ranjit Mijar",
        "Image": ranjit,
        "Personal Side": "I cherish my me time and love hanging out with friends. Whether I am good at it or not, I enjoy playing any game. As an animal lover, I adore being with my pet lab, Mousse. I am passionate about exploring new trends in AI and discovering innovative ways to approach things.",
        "Funny Job Title": "Chief Curiosity Officer (CCO)",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/ranjitmijar?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAADb-9v0BJBKiy7KQgXfXuEQAgroO-MR2n_Q&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BcMCyNEIWQ02bKVOUE1kFCQ%3D%3D"
    },
    {
        "Sr no.": 17,
        "Name": "Christina Murzello",
        "Image": christina,
        "Personal Side": "I am a caring and energetic individual who loves being of service to others, often visiting the elderly or sick in the community to offer companionship. A simple, compassionate team player, I'm always ready to help. While my willingness to say \"yes\" brings joy to others, it sometimes challenges my boundaries.",
        "Funny Job Title": "Kindness Crusader",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/christina-murzello-9024b5265?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAEEJIdIB0OyFW4zAyZLjOWYvlfvNu2XXj0U&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BXWWd7ap8TyGNebXo%2BstC1w%3D%3D"
    },
    {
        "Sr no.": 18,
        "Name": "Anisur Rahman",
        "Image": anisur,
        "Personal Side": "I am a passionate badminton enthusiast who loves playing and watching matches, from local games to international tournaments.  Adventure books and action-packed Tamil and English movies fuel my imagination.  Traveling is my favorite hobby \u2014 be it exploring new places for work, enjoying trips with friends and family, or embracing solo adventures for true thrill.",
        "Funny Job Title": "Action Movie & Shuttlecock Strategist\n",
        "Photograph": "Received",
        "LinkedIn Profile": "https://www.linkedin.com/in/md-anisur-rahman-02765831/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BiLFFlRPfS4Sn2QVs71wxWw%3D%3D"
    },
];
